import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Auto-refresh on 401
API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url?.includes("/auth/")) {
      original._retry = true;
      try {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true });
        return API(original);
      } catch {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

/** Format ISO date to WIB (Asia/Jakarta GMT+7) */
export function formatWIB(iso, opts = {}) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    const defaults = { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta", hour12: false };
    return d.toLocaleString("id-ID", { ...defaults, ...opts });
  } catch {
    return iso;
  }
}

/** Format ISO date to WIB short (just date) */
export function formatWIBDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Jakarta" });
  } catch {
    return iso;
  }
}

/** Format ISO date to WIB time only */
export function formatWIBTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "Asia/Jakarta", hour12: false });
  } catch {
    return iso;
  }
}

/** Get today's date in YYYY-MM-DD format (WIB) */
export function todayWIB() {
  const now = new Date();
  const wib = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Jakarta" }));
  return wib.toISOString().split("T")[0];
}

export default API;
